import React from "react";
import { EdgeProps, getBezierPath, BaseEdge } from "reactflow";

interface EdgeData {
  onDelete?: (id: string) => void;
}

const EdgeWithButton: React.FC<EdgeProps<EdgeData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const onEdgeClick = (evt: React.MouseEvent, id: string) => {
    evt.stopPropagation();
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: selected ? "#2563eb" : "#9ca3af",
          strokeWidth: selected ? 3 : 2,
          transition: "all 0.2s ease",
        }}
      />
      {selected && (
        <foreignObject
          width={32}
          height={32}
          x={labelX - 16}
          y={labelY - 16}
          className="edge-button-wrapper"
          requiredExtensions="http://www.w3.org/1999/xhtml">
          <div
            className="edge-delete-button"
            onClick={(evt) => onEdgeClick(evt, id)}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
        </foreignObject>
      )}
    </>
  );
};

export default EdgeWithButton;
